module.exports = __webpack_public_path__ + "cd5719b20fd08d888184a9877d9dcdcd.png";